"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
const three_1 = require("three");
// eslint-disable-next-line import/no-cycle
const OBB_js_1 = require("three/examples/jsm/math/OBB.js");
const notifications = __importStar(require("../../../locales/en/notifications.json"));
// eslint-disable-next-line import/no-cycle
const types_1 = require("../../../store/types");
// eslint-disable-next-line import/no-cycle
const _1 = require(".");
// eslint-disable-next-line import/no-cycle
const ClientUtils = __importStar(require("../../../utils/utils"));
const consts_1 = require("../../../store/tools/consts");
// eslint-disable-next-line import/no-cycle
const utils_1 = require("../../../utils");
// eslint-disable-next-line import/no-cycle
const commands_1 = require("../commands");
const consts_2 = require("../consts");
// eslint-disable-next-line import/no-cycle
const historyService_1 = require("../history/historyService");
// eslint-disable-next-line import/no-cycle
const TransformControlsInitial_1 = require("../custom-components/controls/TransformControlsInitial");
// eslint-disable-next-line import/no-cycle
const loaders_1 = require("../loaders");
const events_1 = require("../../../consts/events");
// eslint-disable-next-line import/no-cycle
const utils_2 = require("../utils");
// eslint-disable-next-line import/no-cycle
const utils_3d_1 = require("../utils/utils.3d");
// eslint-disable-next-line import/no-cycle
const models_1 = require("../models");
// eslint-disable-next-line import/no-cycle
const Panel_model_3d_1 = __importDefault(require("../models/Panel.model.3d"));
const Cad3d_scss_1 = __importDefault(require("../Cad3d.scss"));
const consts_3 = require("../consts/consts");
// eslint-disable-next-line import/no-cycle
const CapHelper_1 = __importDefault(require("./CapHelper"));
// eslint-disable-next-line import/no-cycle
const AnchorDetection_3d_1 = require("./AnchorDetection.3d");
// eslint-disable-next-line import/no-cycle
const events_2 = require("../../../utils/events");
// eslint-disable-next-line import/no-cycle
const ConnectionManager_3d_1 = __importDefault(require("./ConnectionManager.3d"));
const DragControls_1 = require("../custom-components/controls/DragControls");
const BaseObject3D_3d_1 = require("./BaseObject3D.3d");
const PlasticPanelCutouts_3d_1 = require("./PlasticPanelCutouts.3d");
class DesignProMain {
    get copyInProgress() {
        return this.copyingObjects.length > 0;
    }
    constructor(viewer) {
        this.anchorTestResult = null;
        this.historyService = new historyService_1.HistoryService();
        this.uuidScaleLast = '';
        this.dragControlsDisabledDuringMouseDown = false;
        this.insertLock = false;
        this.drawingAngledLock = false;
        this.halfSideAngled = null;
        this.prevScalingAxis = '';
        this.uuidScalePanelLast = '';
        this.draggingInProgress = false;
        this.disableFeatures = false;
        this.scalingInProgress = false;
        this.transformationInProgress = false;
        this.scalingDirection = consts_2.consts.DEFAULT_SCALING_DIRECTION; // in world coordinates
        this.insertedObjectInitialPosition = new three_1.Vector3(0, 0, 0);
        this.objectNeighborNormal = new three_1.Vector3(0, 0, 1);
        this.insertingObjectDetails = null;
        this.copyingObjects = [];
        this.copyBuffer = [];
        this.selectedCatalogItem = null;
        this.panelInsertionType = types_1.PANEL_INSERTION_TYPE.DEFAULT;
        this.loader = new loaders_1.DRCLoaderHelper();
        this.boundHandleKeyDown = this.handleKeyDown.bind(this);
        this.boundHandleKeyUp = this.handleKeyUp.bind(this);
        this.boundAddCatalogItem = (event) => {
            this.startObjectInserting.call(this, event.detail);
        };
        this.getMoveToBorderPosition = (objectsDiffMin, objectsDiffMax, neighborBoundingBox, objectSize, threshold, normal) => {
            let movePosition = null;
            const objectPosition = this.snappingTool.getObject().position;
            if (objectsDiffMin < threshold || (objectsDiffMin < 0 && objectsDiffMin > -objectSize)) {
                movePosition = new three_1.Vector3((0, utils_3d_1.areNotEqual)(normal.x, 0) ? neighborBoundingBox.min.x + objectSize / 2 : objectPosition.x, (0, utils_3d_1.areNotEqual)(normal.y, 0) ? neighborBoundingBox.min.y + objectSize / 2 : objectPosition.y, (0, utils_3d_1.areNotEqual)(normal.z, 0) ? neighborBoundingBox.min.z + objectSize / 2 : objectPosition.z);
                return movePosition;
            }
            if (objectsDiffMax < threshold || (objectsDiffMax < 0 && objectsDiffMax > -objectSize)) {
                movePosition = new three_1.Vector3((0, utils_3d_1.areNotEqual)(normal.x, 0) ? neighborBoundingBox.max.x - objectSize / 2 : objectPosition.x, (0, utils_3d_1.areNotEqual)(normal.y, 0) ? neighborBoundingBox.max.y - objectSize / 2 : objectPosition.y, (0, utils_3d_1.areNotEqual)(normal.z, 0) ? neighborBoundingBox.max.z - objectSize / 2 : objectPosition.z);
                return movePosition;
            }
            return movePosition;
        };
        this.checkBorderPosition = (normal, threshold) => {
            var _a;
            if (!this.snappingTool.getObject()) {
                return undefined;
            }
            let movePosition = null;
            const objectBoundingBox = utils_2.Utils.getAABBox(this.snappingTool.getObject());
            const neighborObjectId = (_a = this.objectNeighbor) === null || _a === void 0 ? void 0 : _a.object.name.split('|')[1];
            if (!neighborObjectId) {
                return undefined;
            }
            const neighborObject = this.viewer.getObjectById(neighborObjectId);
            if (!neighborObject) {
                return undefined;
            }
            const neighborBoundingBox = utils_2.Utils.getAABBox(neighborObject);
            const objectX = objectBoundingBox.max.x - objectBoundingBox.min.x;
            const objectY = objectBoundingBox.max.y - objectBoundingBox.min.y;
            const objectZ = objectBoundingBox.max.z - objectBoundingBox.min.z;
            const objectsDiffMinX = objectBoundingBox.min.x - neighborBoundingBox.min.x;
            const objectsDiffMaxX = neighborBoundingBox.max.x - objectBoundingBox.max.x;
            const objectsDiffMinY = objectBoundingBox.min.y - neighborBoundingBox.min.y;
            const objectsDiffMaxY = neighborBoundingBox.max.y - objectBoundingBox.max.y;
            const objectsDiffMinZ = objectBoundingBox.min.z - neighborBoundingBox.min.z;
            const objectsDiffMaxZ = neighborBoundingBox.max.z - objectBoundingBox.max.z;
            if ((0, utils_3d_1.areNotEqual)(normal.x, 0)) {
                if ((0, utils_3d_1.areNotEqual)(neighborObject.directionNormal.y, 0)) {
                    movePosition = this.getMoveToBorderPosition(objectsDiffMinY, objectsDiffMaxY, neighborBoundingBox, objectY, threshold, neighborObject.directionNormal);
                }
                else if ((0, utils_3d_1.areNotEqual)(neighborObject.directionNormal.z, 0)) {
                    movePosition = this.getMoveToBorderPosition(objectsDiffMinZ, objectsDiffMaxZ, neighborBoundingBox, objectZ, threshold, neighborObject.directionNormal);
                }
            }
            if ((0, utils_3d_1.areNotEqual)(normal.y, 0)) {
                if ((0, utils_3d_1.areNotEqual)(neighborObject.directionNormal.x, 0)) {
                    movePosition = this.getMoveToBorderPosition(objectsDiffMinX, objectsDiffMaxX, neighborBoundingBox, objectX, threshold, neighborObject.directionNormal);
                }
                else if ((0, utils_3d_1.areNotEqual)(neighborObject.directionNormal.z, 0)) {
                    movePosition = this.getMoveToBorderPosition(objectsDiffMinZ, objectsDiffMaxZ, neighborBoundingBox, objectZ, threshold, neighborObject.directionNormal);
                }
            }
            if ((0, utils_3d_1.areNotEqual)(normal.z, 0)) {
                if ((0, utils_3d_1.areNotEqual)(neighborObject.directionNormal.x, 0)) {
                    movePosition = this.getMoveToBorderPosition(objectsDiffMinX, objectsDiffMaxX, neighborBoundingBox, objectX, threshold, neighborObject.directionNormal);
                }
                else if ((0, utils_3d_1.areNotEqual)(neighborObject.directionNormal.y, 0)) {
                    movePosition = this.getMoveToBorderPosition(objectsDiffMinY, objectsDiffMaxY, neighborBoundingBox, objectY, threshold, neighborObject.directionNormal);
                }
            }
            return movePosition;
        };
        this.startObjectInserting = (item) => {
            var _a;
            // Remove dimensions display on select another item if user selects another object in the widget
            this.dimensioningTool.dispose();
            this.selectedCatalogItem = item;
            const previousId = (_a = this.scalingTool.getObject()) === null || _a === void 0 ? void 0 : _a.partDetails.itemNumber;
            this.removeTransformControlsFromScene();
            this.terminatePartInserting();
            this.transformControlsInitial.detach();
            this.finalizeObjectsInsertion();
            this.selectionTool.unselectAll();
            const partId = item.item_number;
            if (this.viewer.props.selectedTool === 'draw' && partId === previousId) {
                this.viewer.props.setToolToDefault();
                return;
            }
            this.viewer.props.setLoadingModel(true);
            this.loadModels([item]).then(([loadedModel]) => {
                if (loadedModel) {
                    this.onModelFileLoaded(loadedModel);
                }
            });
        };
        this.viewer = viewer;
        this.init();
    }
    handleScaling() {
        if (!this.transformControlsInitial || !this.transformControlsInitial.object) {
            return;
        }
        const scaledObject = this.transformControlsInitial.object;
        if (scaledObject.type === 'Panel') {
            if (this.uuidScalePanelLast !== scaledObject.uuid ||
                this.prevScalingAxis !== this.transformControlsInitial.getScalingAxis()) {
                this.uuidScalePanelLast = scaledObject.uuid;
                this.prevScalingAxis = this.transformControlsInitial.getScalingAxis();
                this.updateScalingPanelCollision();
            }
            else {
                this.checkScalingPanelCollision();
                scaledObject.checkAndFixSize();
            }
            this.dimensioningTool.definePanelDimensions(scaledObject);
        }
        else if (this.uuidScaleLast !== scaledObject.uuid) {
            this.uuidScaleLast = scaledObject.uuid;
            this.updateScalingCollision();
        }
        else {
            // todo it might be worth extending the updateScalingCollision function to avoid maxPositiveCoord < maxNegativeCoord and then remove this "if" condition
            if (this.maxPositiveCoord && this.maxNegativeCoord && this.maxPositiveCoord < this.maxNegativeCoord) {
                this.updateScalingCollision();
            }
            this.checkScalingCollision();
        }
    }
    handleTranslation() {
        if (!this.transformControlsInitial || !this.transformControlsInitial.object) {
            return;
        }
        const object = this.transformControlsInitial.object;
        const diff = object.position.clone().sub(object.snappedAt);
        if (Math.abs(diff.x + diff.y + diff.z) <= consts_2.consts.SNAP_BY_PLANE_THRESHOLD && object.planeSnapped) {
            const snapDiff = object.position.clone().sub(object.oldCoord);
            this.viewer.selectedObjects.forEach((item) => {
                item.setPosition(item.position.clone().sub(snapDiff));
            });
        }
        else if (!object.oldCoord.equals(object.position)) {
            this.snapHelper.snapObjectByBoundingBox(object, object.position.clone().sub(object.oldCoord));
            const { snapped } = this.snapHelper.try2SnapObjByBoxCenter(object, object.directionNormal);
            if (snapped) {
                this.viewer.collisionProcessor.notifyObjectUpdated(object, false, false);
                this.snapHelper.try2SnapObjByBoxCenter(object, object.directionNormal);
            }
            this.dimensioningTool.displayDistances(utils_2.ConnectionUtils.isObjectSnapped(object, this.viewer));
            object.oldCoord.copy(object.position);
        }
    }
    onTransformControlsObjectChange() {
        if (this.transformControlsInitial.mode === consts_3.TRANSFORM_MODE.SCALE) {
            this.scalingInProgress = this.transformControlsInitial.dragging;
        }
        if (!this.transformControlsInitial.object || !(this.transformControlsInitial.object instanceof _1.BaseObject3D)) {
            return;
        }
        if (this.transformControlsInitial.getMode() === consts_3.TRANSFORM_MODE.SCALE) {
            this.handleScaling();
        }
        else {
            this.uuidScaleLast = '';
            this.uuidScalePanelLast = '';
        }
        if (this.transformControlsInitial.getMode() === consts_3.TRANSFORM_MODE.TRANSLATE) {
            this.handleTranslation();
        }
        const { object } = this.transformControlsInitial;
        if (object && object.connectedItems.length > 0 && (object instanceof Panel_model_3d_1.default || object instanceof models_1.Extrusion)) {
            this.snappingTool.updateIntersectionRectangles(object);
        }
        const customObjects = this.viewer.getScene().children.filter((child) => child.isCustomObject);
        if (customObjects.length) {
            this.scalingTool.setScalingValuesForGrid();
        }
        this.scalingTool.displayScalingValue(object);
        this.viewer.collisionProcessor.notifyObjectUpdated(object, false, false);
        this.viewer.updateViewer();
    }
    getTransformObjects() {
        const mode = this.transformControlsInitial.getMode();
        const masterPart = this.transformControlsInitial.object;
        const transformObjects = [consts_3.TRANSFORM_MODE.SCALE, consts_3.TRANSFORM_MODE.NONE].includes(mode)
            ? [masterPart]
            : [...this.viewer.selectedObjects];
        transformObjects.forEach((object) => {
            object.getTransformChildObjects().forEach((childObject) => {
                if (!transformObjects.includes(childObject)) {
                    transformObjects.push(childObject);
                }
            });
        });
        return transformObjects;
    }
    init() {
        const DEFAULT_EXTRUDE_STEP = this.viewer.isImperialMeasurementUsed
            ? consts_2.consts.DEFAULT_EXTRUDE_STEP
            : consts_2.consts.DEFAULT_EXTRUDE_STEP_SI;
        this.selectionTool = new _1.SelectionToolHelper(this.viewer, this);
        // init TransformControls untouched
        this.transformControlsInitial = new TransformControlsInitial_1.TransformControls(this.viewer.getCamera(), this.viewer.getRendererDOMElement(), () => this.selectionTool.selectedObjects.length > 1, () => this.selectionTool.selectedObjects);
        this.transformControlsInitial.setScaleSnap(DEFAULT_EXTRUDE_STEP);
        this.transformControlsInitial.setTranslationSnap(DEFAULT_EXTRUDE_STEP);
        this.viewer.getScene().add(this.transformControlsInitial);
        // init DragControls
        this.dragControls = new DragControls_1.DragControls(this.viewer.getCamera(), this.viewer.getRendererDOMElement(), [this.viewer.slidePlane], this.viewer, this);
        // init panel insert helper
        this.panelInsertHelper = new _1.PanelInSlotsHelper(this.viewer);
        // init snapping tool
        this.snappingTool = new _1.SnappingTool(this.viewer, this, this.dragControls);
        // init dimensioning tool
        this.dimensioningTool = new _1.DimensioningTool(this.viewer, this, this.snappingTool);
        // init scaling tool
        this.scalingTool = new _1.ScalingTool(this.viewer, this);
        // init snap helper
        this.snapHelper = new _1.SnapHelper(this.viewer, this.viewer.anchorDetection, this.viewer.collisionProcessor);
        this.capHelper = new CapHelper_1.default(this.viewer, this.snappingTool);
        this.highlightingTool = new _1.HighlightingTool(this.viewer);
        this.connectionManager = new ConnectionManager_3d_1.default(this.viewer);
        this.viewer.getRendererDOMElement().addEventListener('mousemove', this.onMouseMove.bind(this), false);
        this.viewer.getRendererDOMElement().addEventListener('mousedown', this.onMouseDown.bind(this), false);
        this.viewer.getRendererDOMElement().addEventListener('mouseup', this.onMouseUp.bind(this), false);
        this.viewer.getRendererDOMElement().addEventListener('contextmenu', (e) => {
            e.preventDefault();
        });
        this.transformControlsInitial.addEventListener('objectChange', (p) => {
            this.onTransformControlsObjectChange();
        });
        this.transformControlsInitial.addEventListener('mouseDown', (p) => {
            const transformObjects = this.getTransformObjects();
            transformObjects.forEach((transformObject) => {
                transformObject.connectedItems.forEach((item) => {
                    var _a;
                    (_a = this.connectionManager.findConnectionObjectBetween(transformObject.uuid, item.uuid)) === null || _a === void 0 ? void 0 : _a.hideFasteners();
                });
                transformObject.positionOnDown = transformObject.position.clone();
                transformObject.quaternionOnDown = transformObject.quaternion.clone();
                transformObject.scaleOnDown = transformObject.getScale().clone();
            });
            this.viewer.getControls().enabled = false;
        });
        this.transformControlsInitial.addEventListener('mouseUp', (p) => {
            const viewerForTransformCommand = this.viewer;
            const masterPart = this.transformControlsInitial.object;
            const mode = this.transformControlsInitial.getMode();
            const transformObjects = this.getTransformObjects();
            if (masterPart) {
                switch (mode) {
                    case consts_3.TRANSFORM_MODE.TRANSLATE:
                        if (!masterPart.positionOnDown.equals(masterPart.position)) {
                            this.historyService.execute(new commands_1.SetPositionCommand(transformObjects, viewerForTransformCommand, this.historyService));
                        }
                        break;
                    case consts_3.TRANSFORM_MODE.ROTATE:
                        if (!masterPart.quaternionOnDown.equals(masterPart.quaternion)) {
                            this.historyService.execute(new commands_1.SetRotationCommand(transformObjects, viewerForTransformCommand, this.historyService));
                        }
                        break;
                    case consts_3.TRANSFORM_MODE.SCALE:
                        if (!masterPart.scaleOnDown.equals(masterPart.getScale())) {
                            this.historyService.execute(new commands_1.SetScaleCommand(masterPart, viewerForTransformCommand, this.historyService));
                        }
                        break;
                    default:
                        break;
                }
            }
            transformObjects.forEach((transformObject) => {
                transformObject.connectedItems.forEach((item) => {
                    var _a;
                    (_a = this.connectionManager.findConnectionObjectBetween(transformObject.uuid, item.uuid)) === null || _a === void 0 ? void 0 : _a.showFasteners();
                });
            });
            this.viewer.getControls().enabled = true;
            this.viewer.getDesignProMain().highlightingTool.clearConnectionHighlight();
            this.snapHelper.clearPlaneHighlight();
        });
        document.addEventListener('keydown', this.boundHandleKeyDown, false);
        document.addEventListener('keyup', this.boundHandleKeyUp, false);
        // History Service listeners
        this.historyService.listen('historyChanged', (_p) => {
            this.viewer.props.updateHistoryControls(this.historyService.getUndos(), this.historyService.getRedos());
        });
        this.historyService.listen('historyChanged', () => this.viewer.updateBuildPlanePosition(this.scalingInProgress));
        document.body.addEventListener(events_1.addCatalogItem, this.boundAddCatalogItem, false);
    }
    dispose() {
        document.removeEventListener('keydown', this.boundHandleKeyDown, false);
        document.removeEventListener('keyup', this.boundHandleKeyUp, false);
        document.body.removeEventListener(events_1.addCatalogItem, this.boundAddCatalogItem, false);
        this.connectionManager.dispose();
        this.dragControls.dispose();
    }
    rotateSlidePlane() {
        var _a;
        const neighborObjectId = (_a = this.objectNeighbor) === null || _a === void 0 ? void 0 : _a.object.name.split('|')[1];
        if (!neighborObjectId) {
            return;
        }
        const neighborObject = this.viewer.getObjectById(neighborObjectId);
        const objectNeighborDirection = neighborObject.directionNormal;
        const { objectNeighborNormal } = this;
        this.viewer.slidePlane.position.copy(this.scalingTool.getObject().position);
        if ((0, utils_3d_1.areNotEqual)(objectNeighborNormal.x, 0)) {
            if ((0, utils_3d_1.areNotEqual)(objectNeighborDirection.z, 0)) {
                this.viewer.slidePlane.rotateX(Math.PI / 2);
            }
        }
        else if ((0, utils_3d_1.areNotEqual)(objectNeighborNormal.y, 0)) {
            if ((0, utils_3d_1.areNotEqual)(objectNeighborDirection.z, 0)) {
                this.viewer.slidePlane.rotateY(Math.PI / 2);
            }
        }
        else if ((0, utils_3d_1.areNotEqual)(objectNeighborNormal.z, 0)) {
            if ((0, utils_3d_1.areNotEqual)(objectNeighborDirection.x, 0)) {
                this.viewer.slidePlane.rotateX(Math.PI / 2);
            }
            else if ((0, utils_3d_1.areNotEqual)(objectNeighborDirection.y, 0)) {
                this.viewer.slidePlane.rotateY(Math.PI / 2);
            }
        }
    }
    areInCopyingObjects(...objects) {
        const copyingObjectsIds = this.copyingObjects.map((object) => object.uuid);
        return objects.every((object) => object && copyingObjectsIds.includes(object.uuid));
    }
    refreshLabels() {
        const lengthLabel = document.getElementById(Cad3d_scss_1.default.lengthLabel);
        const lengthEditableLabel = document.getElementById(Cad3d_scss_1.default.lengthEditableLabel);
        const angledLengthLabel = document.getElementById(Cad3d_scss_1.default.angleLabel);
        let selectedObject;
        if (this.scalingInProgress ||
            (this.transformationInProgress &&
                this.transformControlsInitial.mode === consts_3.TRANSFORM_MODE.SCALE &&
                this.selectionTool.selectedObjects.length === 1)) {
            selectedObject = this.selectionTool.selectedObjects[0];
        }
        const NONE = 'none';
        const BLOCK = 'block';
        if (selectedObject) {
            if (selectedObject.type === 'Extrusion') {
                if (lengthEditableLabel) {
                    lengthEditableLabel.style.display = selectedObject.scalingAngle === 0 ? BLOCK : NONE;
                }
            }
            else if (lengthLabel) {
                lengthLabel.style.display = selectedObject.scalingAngle === 0 ? BLOCK : NONE;
            }
            if (angledLengthLabel) {
                angledLengthLabel.style.display = selectedObject.scalingAngle !== 0 ? BLOCK : NONE;
            }
        }
        else {
            if (lengthLabel) {
                lengthLabel.style.display = NONE;
            }
            if (lengthEditableLabel) {
                lengthEditableLabel.style.display = NONE;
            }
            if (angledLengthLabel) {
                angledLengthLabel.style.display = NONE;
            }
        }
    }
    onMouseMove(event) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.lastMouseMoveEvent = event;
        this.refreshLabels();
        if (this.transformationInProgress || !this.viewer.getControls().enabled || this.insertLock) {
            return;
        }
        if (event.buttons !== 0) {
            if (this.viewer.getControls().enableRotate) {
                return;
            }
            if (this.scalingTool.getObject() && this.scalingInProgress) {
                this.scalingTool.displayScalingValue(this.scalingTool.getObject());
            }
            else {
                this.dimensioningTool.displayDistances(false);
            }
            return;
        }
        const { objectsIntersections } = this.viewer;
        let intersectsWithPlane = [];
        let intersectsWithBackgroundPlane = [];
        const snappingObject = this.snappingTool.getObject();
        if ((snappingObject === null || snappingObject === void 0 ? void 0 : snappingObject.isScalable) && this.scalingInProgress) {
            this.viewer.viewCubeEventsEnabled = false;
            this.viewer.disableViewCubeEvents();
        }
        else {
            this.viewer.viewCubeEventsEnabled = true;
            this.viewer.enableViewCubeEvents();
        }
        if (!snappingObject) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        this.intersectionPointOnTheMesh = objectsIntersections === null || objectsIntersections === void 0 ? void 0 : objectsIntersections.outerBox;
        intersectsWithPlane = this.viewer.detectIntersection(event, this.viewer.slidePlane, true);
        const scaleObjectOnInsert = snappingObject.isScalable && this.scalingInProgress;
        if (scaleObjectOnInsert) {
            intersectsWithBackgroundPlane = this.viewer.detectIntersection(event, this.viewer.getBackgroundPlane(), true);
            const neighborObjectId = (_a = this.objectNeighbor) === null || _a === void 0 ? void 0 : _a.object.name.split('|')[1];
            const neighborObject = this.viewer.getObjectById(neighborObjectId);
            const snappingToNeighborsEnd = this.snappingTool.isSnappedToNeighborsEnd;
            if (utils_2.Utils.isPlasticPanel(snappingObject) && this.panelInsertionType === types_1.PANEL_INSERTION_TYPE.SIDE_OR_END) {
                this.scalingTool.scalePanelToPointer();
                return;
            }
            if (((!this.viewer.props.drawingAngled || !neighborObject) && !this.drawingAngledLock) ||
                (this.viewer.props.drawingAngled && snappingToNeighborsEnd) ||
                (neighborObject === null || neighborObject === void 0 ? void 0 : neighborObject.type) !== 'Extrusion') {
                this.scalingTool.detectFutureScalingDirection(utils_2.Utils.getCameraToPointerLineFromEvent(event, this.viewer.getCamera()));
            }
            else {
                if (this.halfSideAngled === null) {
                    const box = utils_2.Utils.getAABBox(this.scalingTool.getObject());
                    const sizeX = box.max.x - box.min.x;
                    const sizeY = box.max.y - box.min.y;
                    const sizeZ = box.max.z - box.min.z;
                    this.halfSideAngled = sizeX > sizeY ? sizeX : sizeY;
                    this.halfSideAngled = sizeZ > this.halfSideAngled ? sizeZ : this.halfSideAngled;
                    this.halfSideAngled *= 0.5;
                }
                this.drawingAngledLock = true;
                this.scalingTool.detectAngledScalingDirection(((_b = intersectsWithPlane[0]) === null || _b === void 0 ? void 0 : _b.point) || ((_c = intersectsWithBackgroundPlane[0]) === null || _c === void 0 ? void 0 : _c.point), neighborObject.directionNormal, this.objectNeighborNormal, neighborObject.uuid);
            }
            if (intersectsWithPlane.length || intersectsWithBackgroundPlane.length) {
                this.scalingTool.scaleObjectToPointer(((_d = intersectsWithPlane[0]) === null || _d === void 0 ? void 0 : _d.point) || ((_e = intersectsWithBackgroundPlane[0]) === null || _e === void 0 ? void 0 : _e.point), (_f = intersectsWithBackgroundPlane[0]) === null || _f === void 0 ? void 0 : _f.point, null);
            }
        }
        else {
            if ((!(objectsIntersections === null || objectsIntersections === void 0 ? void 0 : objectsIntersections.customObject) ||
                !snappingObject ||
                !this.intersectionPointOnTheMesh ||
                (this.intersectionPointOnTheMesh.object &&
                    this.areInCopyingObjects(snappingObject, this.intersectionPointOnTheMesh.object.parent))) &&
                this.draggingInProgress) {
                this.dimensioningTool.displayDistances(false);
            }
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
            this.objectNeighborNormal = (_h = (_g = this.intersectionPointOnTheMesh) === null || _g === void 0 ? void 0 : _g.face) === null || _h === void 0 ? void 0 : _h.normal;
            if (snappingObject.snapped) {
                if ((objectsIntersections === null || objectsIntersections === void 0 ? void 0 : objectsIntersections.buildPlane) ||
                    (objectsIntersections === null || objectsIntersections === void 0 ? void 0 : objectsIntersections.outerBox) ||
                    ((_j = this.snappingTool) === null || _j === void 0 ? void 0 : _j.isSomethingHighlighted())) {
                    snappingObject.visible = true;
                }
                else {
                    snappingObject.visible = false;
                }
            }
            if ((objectsIntersections === null || objectsIntersections === void 0 ? void 0 : objectsIntersections.customObject) && (!this.copyInProgress || this.isOnlyOneCopyingPart())) {
                this.snapToPointerPositionOnMove();
                if (this.intersectionPointOnTheMesh) {
                    this.dimensioningTool.displayDistances(true);
                    this.snappingTool.getObject().snapped = true;
                }
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
                this.objectNeighbor = (objectsIntersections === null || objectsIntersections === void 0 ? void 0 : objectsIntersections.outerBox) || (objectsIntersections === null || objectsIntersections === void 0 ? void 0 : objectsIntersections.backgroundPlane);
            }
            if (!(objectsIntersections === null || objectsIntersections === void 0 ? void 0 : objectsIntersections.customObject)) {
                this.snappingTool.hideHighlightedObject();
                this.highlightingTool.clearConnectionHighlight();
                this.snappingTool.removeTempSnappingChanges();
                if (intersectsWithPlane.length && this.draggingInProgress && !this.dragControls.enabled) {
                    this.dragControls.enabled = true;
                    this.dragControls.surfaceMeshes = [this.viewer.slidePlane];
                    this.dragControls.setPositionShift(null);
                }
            }
        }
    }
    finalizeObjectInsertionOnMouseDown() {
        const canBeInserted = utils_2.Utils.validateIfObjectCanBeInsertedAndShowErrors(this.viewer, this.scalingInProgress);
        if (!canBeInserted) {
            return false;
        }
        this.finalizeObjectsInsertion();
        if (this.selectedCatalogItem) {
            this.startObjectInserting(this.selectedCatalogItem);
        }
        return true;
    }
    onMouseDown(event) {
        if (this.transformationInProgress) {
            return;
        }
        if (event.button === consts_2.consts.BUTTONS.MIDDLE) {
            this.dragControls.enabled = false;
            this.dragControlsDisabledDuringMouseDown = true;
        }
        if (event.button !== consts_2.consts.BUTTONS.LEFT) {
            return;
        }
        this.dimensioningTool.dispose();
        const { selectedTool } = this.viewer.props;
        const isAllowedAction = selectedTool === consts_1.TOOL_STATE.PAN || selectedTool === consts_1.TOOL_STATE.ROTATE_SCENE;
        if (this.viewer.props.isFastenerWidgetShown && !isAllowedAction) {
            utils_1.Events.showNotification({
                message: notifications['fastener-not-selected-warning'],
                type: 'warning',
            });
            return;
        }
        if (this.viewer.props.isItemReplacementWidgetShown && !isAllowedAction) {
            utils_1.Events.showNotification({
                message: notifications['item-replacement-not-closed-warning'],
                type: 'warning',
            });
            return;
        }
        event.preventDefault();
        DesignProMain.confirmActivePlacement(this);
    }
    /** Confirms a keyboard-positioned preview through the active placement flow. */
    confirmPositioningInput() {
        this.dimensioningTool.dispose();
        DesignProMain.confirmActivePlacement(this);
        this.insertLock = false;
    }
    static confirmActivePlacement(main) {
        var _a, _b;
        const snappingObject = main.snappingTool.getObject();
        if (main.draggingInProgress && (snappingObject === null || snappingObject === void 0 ? void 0 : snappingObject.visible) && !main.copyInProgress) {
            main.disableFeatures = true;
            const canBeInserted = utils_2.Utils.validateIfObjectCanBeInsertedAndShowErrors(main.viewer, main.scalingInProgress);
            if (!canBeInserted) {
                return;
            }
            let isScalable = (snappingObject === null || snappingObject === void 0 ? void 0 : snappingObject.partDetails.isScalable) &&
                ((utils_2.Utils.isPlasticPanel(snappingObject) && main.panelInsertionType === types_1.PANEL_INSERTION_TYPE.SIDE_OR_END) ||
                    (snappingObject === null || snappingObject === void 0 ? void 0 : snappingObject.partDetails.scaleAxes) !== 'XY');
            if ((0, utils_3d_1.isCoverComponent)(snappingObject)) {
                isScalable = !(snappingObject === null || snappingObject === void 0 ? void 0 : snappingObject.snapped);
                if (isScalable) {
                    main.setObjectInitialPosition(new three_1.Vector3(0, 0, 0).copy(snappingObject.position));
                }
            }
            if (!(0, utils_3d_1.isCoverComponent)(snappingObject) && !utils_2.Utils.isPlasticPanel(snappingObject) && isScalable) {
                const objectInserted = main.insertObjectPreviewToTheScene();
                if (!objectInserted) {
                    return;
                }
            }
            main.draggingInProgress = false;
            main.dragControls.endDraggingOnMouseCancel = true;
            main.dragControls.dispose();
            main.insertLock = true;
            if (utils_2.Utils.isPlasticPanel(snappingObject) &&
                main.panelInsertionType === types_1.PANEL_INSERTION_TYPE.SIDE_OR_END &&
                !main.snappingTool.neighborObject) {
                main.scalingInProgress = true;
                return;
            }
            const neighborObjectId = (_a = main.objectNeighbor) === null || _a === void 0 ? void 0 : _a.object.name.split('|')[1];
            const neighborObject = main.viewer.getObjectById(neighborObjectId);
            if (main.viewer.props.drawingAngled) {
                if (!main.snappingTool.isSnappedToNeighborsEnd &&
                    ((_b = main.objectNeighbor) === null || _b === void 0 ? void 0 : _b.object) &&
                    (neighborObject === null || neighborObject === void 0 ? void 0 : neighborObject.type) === 'Extrusion') {
                    main.rotateSlidePlane();
                }
                if (main.snappingTool.isSnappedToNeighborsEnd || (neighborObject === null || neighborObject === void 0 ? void 0 : neighborObject.type) !== 'Extrusion') {
                    utils_1.Events.showNotification({
                        message: notifications['angled-extrusion-warning'],
                        type: 'warning',
                    });
                }
            }
            if (!isScalable) {
                main.finalizeObjectInsertionOnMouseDown();
            }
            else if (!main.copyInProgress) {
                main.scalingInProgress = true;
            }
        }
        else if (main.copyInProgress) {
            main.finishCopyObjectsInserting();
        }
        else if (main.scalingInProgress) {
            if (utils_2.Utils.isPlasticPanel(snappingObject) && main.panelInsertionType === types_1.PANEL_INSERTION_TYPE.SIDE_OR_END) {
                main.finalizePanelInsertion();
                if (main.selectedCatalogItem && !main.snappingTool.getObject()) {
                    main.startObjectInserting(main.selectedCatalogItem);
                }
            }
            else {
                main.finalizeObjectInsertionOnMouseDown();
            }
        }
    }
    onMouseUp(event) {
        if (this.dragControlsDisabledDuringMouseDown) {
            this.dragControls.enabled = true;
            this.dragControlsDisabledDuringMouseDown = false;
        }
        if (event.button !== consts_2.consts.BUTTONS.LEFT) {
            return;
        }
        this.insertLock = false;
        event.preventDefault();
        this.viewer.props.setContextMenu({ show: false });
    }
    updateScalingPanelCollision() {
        this.maxPositiveCoord = null;
        this.maxNegativeCoord = null;
    }
    checkScalingPanelCollision() {
        const obj = this.transformControlsInitial.object;
        const objectBox = utils_2.Utils.getAABBox(this.transformControlsInitial.object);
        let direction;
        const mask = new three_1.Vector3(0, 0, 0);
        if (this.prevScalingAxis === consts_3.SCALE_AXES.X) {
            mask.x = 1;
            direction = utils_2.Utils.absVector(obj.xDirection);
        }
        else {
            mask.y = 1;
            direction = utils_2.Utils.absVector(obj.yDirection);
        }
        const initialPanelSize = this.transformControlsInitial.object.isWireMesh()
            ? consts_2.consts.WIRE_MESH_PANEL_INITIAL_SIZE
            : consts_2.consts.PLASTIC_PANEL_INITIAL_SIZE;
        if (this.maxPositiveCoord !== null) {
            const boxPos = objectBox.max.clone().dot(direction);
            if (boxPos > this.maxPositiveCoord) {
                obj.addScale(mask.clone().multiplyScalar((this.maxPositiveCoord - boxPos) / initialPanelSize));
            }
        }
        if (this.maxNegativeCoord !== null) {
            const boxPos = objectBox.min.clone().dot(direction);
            if (boxPos < this.maxNegativeCoord) {
                obj.addScale(mask.clone().multiplyScalar((boxPos - this.maxNegativeCoord) / initialPanelSize));
            }
        }
    }
    updateScalingCollision(object = null) {
        const obj = object || this.transformControlsInitial.object;
        const direction = (0, utils_3d_1.absVector)(obj.directionNormal.clone());
        const excludeIDs = new Set(obj.getCollisionExcludeIds());
        obj.getConnectionExcludeIDs().forEach((excludeId) => excludeIDs.add(excludeId));
        this.viewer
            .getDesignProMain()
            .connectionManager.getRelatedConnectionObjects(obj)
            .forEach((connectionObject) => {
            connectionObject.getFasteners().forEach((fastener) => {
                excludeIDs.add(fastener.uuid);
            });
        });
        const testN = this.viewer.collisionProcessor.getClosestCollision(obj, direction.clone().negate(), excludeIDs);
        const testP = this.viewer.collisionProcessor.getClosestCollision(obj, direction.clone(), excludeIDs);
        if (testP.result && testP.index.distanceToCollision) {
            this.maxPositiveCoord = testP.index.distanceToCollision + obj.position.clone().dot(direction);
            this.positiveObj = this.viewer.getObjectById(this.viewer.collisionProcessor.getObjUUID(testP.index));
        }
        else {
            this.maxPositiveCoord = null;
            this.positiveObj = null;
        }
        if (testN.result && testN.index.distanceToCollision) {
            this.maxNegativeCoord = obj.position.clone().dot(direction) - testN.index.distanceToCollision;
            this.negativeObj = this.viewer.getObjectById(this.viewer.collisionProcessor.getObjUUID(testN.index));
        }
        else {
            this.maxNegativeCoord = null;
            this.negativeObj = null;
        }
    }
    checkScalingCollision() {
        const obj = this.transformControlsInitial.object;
        const sign = obj.directionNormal.x + obj.directionNormal.y + obj.directionNormal.z;
        const direction = obj.directionNormal.clone().multiply(obj.directionNormal);
        let topChildObject;
        let covers;
        if (obj.type === types_1.ITEM_TYPE.EXTRUSION) {
            const childEndFace = this.transformControlsInitial.isReverseScale ? 'A' : 'B';
            topChildObject = obj
                .getEndComponents()
                .find((component) => component.userData.endFace === childEndFace);
            covers = obj.getTransformChildObjects().filter((component) => utils_2.Utils.isCoverComponent(component));
        }
        let maxSnapDistance;
        if (sign > 0) {
            maxSnapDistance = this.maxPositiveCoord;
        }
        else {
            maxSnapDistance = -this.maxNegativeCoord;
        }
        obj.checkAndFixSize();
        const objToCheck = topChildObject !== null && topChildObject !== void 0 ? topChildObject : obj;
        if (sign > 0) {
            if (this.maxPositiveCoord !== null) {
                const positiveCoord = objToCheck.position
                    .clone()
                    .add(obj.directionNormal.clone().multiplyScalar(objToCheck.getLength()))
                    .dot(direction);
                if (positiveCoord > this.maxPositiveCoord) {
                    const delta = this.maxPositiveCoord - positiveCoord;
                    if (topChildObject) {
                        const moveVector = obj.directionNormal.clone().multiplyScalar(delta);
                        topChildObject.translate(moveVector);
                    }
                    const oldScale = obj.getScale().clone();
                    obj.addScaleZ(delta);
                    const newScale = obj.getScale();
                    if (covers) {
                        obj.scaleCoverComponents(oldScale, newScale);
                    }
                }
            }
        }
        else if (this.maxNegativeCoord !== null) {
            const negativeCoord = objToCheck.position
                .clone()
                .add(obj.directionNormal.clone().multiplyScalar(objToCheck.getLength()))
                .dot(direction);
            if (negativeCoord < this.maxNegativeCoord) {
                const delta = negativeCoord - this.maxNegativeCoord;
                if (topChildObject) {
                    const moveVector = obj.directionNormal.clone().multiplyScalar(delta);
                    topChildObject.translate(moveVector);
                }
                const oldScale = obj.getScale().clone();
                obj.addScaleZ(delta);
                const newScale = obj.getScale();
                if (covers) {
                    obj.scaleCoverComponents(oldScale, newScale);
                }
            }
        }
        obj.oldCoord.copy(obj.position);
        const test = this.snapHelper.checkPlaneSnap(obj, obj.position.clone().add(obj.directionNormal.clone().multiplyScalar(obj.getScale().z)), maxSnapDistance);
        if (test.result === true) {
            const delta = test.dist * sign;
            const oldScale = obj.getScale().clone();
            obj.addScaleZ(delta);
            const newScale = obj.getScale();
            if (covers) {
                obj.scaleCoverComponents(oldScale, newScale);
            }
            if (topChildObject) {
                const moveVector = obj.directionNormal.clone().multiplyScalar(test.dist * sign);
                topChildObject.translate(moveVector);
            }
        }
    }
    updateConnectionsAndShowNotifications(...objects) {
        const promisesArray = [];
        const errorsSet = new Set();
        const warningsSet = new Set();
        const updatedObjectsUUIDs = new Set(objects.map((object) => object.uuid));
        let theLastTransformation;
        if (objects.length > 1) {
            const [object] = objects;
            const matrixOnDown = new three_1.Matrix4().compose(object.positionOnDown, object.quaternionOnDown, object.scaleOnDown);
            const currentMatrix = new three_1.Matrix4().compose(object.position, object.quaternion, object.scale);
            theLastTransformation = currentMatrix.multiply(matrixOnDown.invert());
        }
        objects.forEach((object) => {
            const { fastenersVisualizationPromises, errors, warnings, objectsToHighlightInRed } = this.connectionManager.updateConnections(object, theLastTransformation, updatedObjectsUUIDs);
            promisesArray.push(...fastenersVisualizationPromises);
            errors.forEach((error) => errorsSet.add(error));
            warnings.forEach((warning) => warningsSet.add(warning));
            objectsToHighlightInRed.forEach((objectToHighlight) => this.highlightingTool.highlightObject(objectToHighlight));
        });
        this.connectionManager.clearInProgressConnections();
        errorsSet.forEach((error) => utils_1.Events.showNotification({ type: 'error', message: error }));
        warningsSet.forEach((warning) => utils_1.Events.showNotification({ type: 'warning', message: warning }));
        return promisesArray;
    }
    activateFasteners() {
        this.escapeClear();
        this.viewer.getScene().children.forEach((child) => {
            if ((0, utils_3d_1.isBaseObject3D)(child)) {
                const material = child.mesh.material;
                material.transparent = true;
                material.opacity = consts_2.consts.FASTENER_MODE_OPACITY;
                material.needsUpdate = true;
            }
            else if ((0, utils_3d_1.isConnection)(child)) {
                const connectionObject = child;
                connectionObject.makeSphereVisible();
                connectionObject.showSelectionBox();
            }
        });
    }
    deactivateFasteners() {
        this.viewer.getScene().children.forEach((child) => {
            if ((0, utils_3d_1.isBaseObject3D)(child)) {
                const material = child.mesh.material;
                material.transparent = false;
                material.opacity = 1.0;
                material.needsUpdate = true;
            }
            else if ((0, utils_3d_1.isConnection)(child)) {
                const connectionObject = child;
                connectionObject.unselectFasteners();
                connectionObject.unselectSphere();
                connectionObject.hideSelectionBox();
                connectionObject.makeSphereInvisible();
            }
        });
    }
    escapeClear() {
        this.disableFeatures = false;
        this.draggingInProgress = false;
        this.halfSideAngled = null;
        this.drawingAngledLock = false;
        this.snapHelper.clearPlaneHighlight();
        const scene = this.viewer.getScene();
        scene.remove(scene.getObjectByName('dirOnSnapY'));
        scene.remove(scene.getObjectByName('dirOnSnapX'));
        scene.remove(scene.getObjectByName('dirOnSnapZ'));
        this.snappingTool.hideHighlightedObject();
        this.highlightingTool.clearConnectionHighlight();
        this.dimensioningTool.dispose();
        this.refreshLabels();
        this.viewer.angleArc.visible = false;
        this.viewer.props.unselectCatalogItems();
        // removing the sliced mesh associated with this object if angled
        if (this.scalingTool.getObject()) {
            const tempSlicedToRemove = scene.getObjectByProperty('name', `TempSliced|${this.scalingTool.getObject().uuid}`);
            if (tempSlicedToRemove) {
                this.viewer.getScene().remove(tempSlicedToRemove);
            }
        }
        this.drawingAngledLock = false;
    }
    handleKeyDown(event) {
        switch (event.code) {
            case 'Escape':
                // Escape
                if (this.transformationInProgress && this.viewer.mouseDown) {
                    return;
                }
                this.escapeClear();
                this.viewer.props.setContextMenu({ show: false });
                break;
            case 'Delete':
                // Delete
                // TODO: update connections
                if (!this.viewer.props.isFastenerWidgetShown &&
                    !this.viewer.props.isOrderCompleted &&
                    !this.viewer.props.isProjectViewOnly &&
                    !this.viewer.props.isProjectArchived &&
                    this.viewer.props.selectedTool !== consts_1.TOOL_STATE.DRAW) {
                    if (!['input', 'textarea'].includes(event.target.tagName.toLowerCase())) {
                        const objects = [];
                        this.selectionTool.selectedObjects.forEach((so) => {
                            objects.push(so.uuid);
                        });
                        this.removeObjects(objects);
                        this.selectionTool.unselectAll();
                        this.viewer.props.setContextMenu({ show: false });
                    }
                }
                break;
            case 'KeyZ':
                // z
                if (event.ctrlKey || event.metaKey) {
                    if (!['input', 'textarea'].includes(event.target.tagName.toLowerCase())) {
                        this.undoCommand();
                    }
                }
                break;
            case 'KeyY':
                // y
                if (event.ctrlKey || event.metaKey) {
                    if (!['input', 'textarea'].includes(event.target.tagName.toLowerCase())) {
                        this.redoCommand();
                    }
                }
                break;
            case 'KeyC':
                // c
                if (event.ctrlKey || event.metaKey) {
                    if (!['input', 'textarea'].includes(event.target.tagName.toLowerCase())) {
                        this.copyAction();
                    }
                }
                break;
            case 'KeyV':
                // v
                if (event.ctrlKey || event.metaKey) {
                    if (!['input', 'textarea'].includes(event.target.tagName.toLowerCase())) {
                        this.pasteAction();
                    }
                }
                break;
            case 'KeyA':
                // a
                if (!['input', 'textarea'].includes(event.target.tagName.toLowerCase())) {
                    if (event.ctrlKey || event.metaKey) {
                        event.preventDefault();
                        this.viewer.props.setSelectedTool(consts_1.TOOL_STATE.NAVIGATE);
                        this.selectionTool.selectAll();
                        this.draggingInProgress = false;
                    }
                    else {
                        this.draggingInProgress = true;
                        this.snappingTool.getObject().snapped = false;
                    }
                }
                break;
            case 'Space':
                // space
                const isPositioningInput = event.target.id === 'positioningLabelInput';
                if (isPositioningInput || !['input', 'textarea'].includes(event.target.tagName.toLowerCase())) {
                    const object = this.snappingTool.getObject();
                    if (object) {
                        if ((0, utils_3d_1.isMeshRetainerAssembly)(object) || (0, utils_3d_1.isPanelRetainer)(object)) {
                            object.additionalRotationAngle += Math.PI;
                        }
                        else {
                            object.additionalRotationAngle += Math.PI / 2;
                        }
                        object.additionalRotationAngle = utils_2.Utils.modulus(object.additionalRotationAngle, Math.PI * 2);
                        event.preventDefault();
                        if (this.lastMouseMoveEvent) {
                            this.onMouseMove(this.lastMouseMoveEvent);
                            this.dragControls.onDocumentMouseMove(this.lastMouseMoveEvent);
                        }
                    }
                }
                break;
            default:
                break;
        }
    }
    handleKeyUp(event) {
        if (event.code === 'ControlLeft') {
            // Ctrl Left
            this.snapHelper.activate();
        }
    }
    objectFitsNeighborSide(neighbor, normal) {
        let objectFits = true;
        let shouldBeRotated = true;
        const objectBoundingBox = utils_2.Utils.getAABBox(this.snappingTool.getObject());
        const neighborBoundingBox = utils_2.Utils.getAABBox(neighbor);
        const objectX = ClientUtils.roundToDecimals(objectBoundingBox.max.x - objectBoundingBox.min.x, 3);
        const objectY = ClientUtils.roundToDecimals(objectBoundingBox.max.y - objectBoundingBox.min.y, 3);
        const objectZ = ClientUtils.roundToDecimals(objectBoundingBox.max.z - objectBoundingBox.min.z, 3);
        const neighborX = ClientUtils.roundToDecimals(neighborBoundingBox.max.x - neighborBoundingBox.min.x, 3);
        const neighborY = ClientUtils.roundToDecimals(neighborBoundingBox.max.y - neighborBoundingBox.min.y, 3);
        const neighborZ = ClientUtils.roundToDecimals(neighborBoundingBox.max.z - neighborBoundingBox.min.z, 3);
        if ((0, utils_3d_1.areNotEqual)(normal.x, 0)) {
            objectFits = objectY <= neighborY && objectZ <= neighborZ;
            shouldBeRotated = (0, utils_3d_1.areEqual)(objectY, neighborZ) || (0, utils_3d_1.areEqual)(objectZ, neighborY);
        }
        else if ((0, utils_3d_1.areNotEqual)(normal.y, 0)) {
            objectFits = objectX <= neighborX && objectZ <= neighborZ;
            shouldBeRotated = (0, utils_3d_1.areEqual)(objectX, neighborZ) || (0, utils_3d_1.areEqual)(objectZ, neighborX);
        }
        else if ((0, utils_3d_1.areNotEqual)(normal.z, 0)) {
            objectFits = objectX <= neighborX && objectY <= neighborY;
            shouldBeRotated = (0, utils_3d_1.areEqual)(objectX, neighborY) || (0, utils_3d_1.areEqual)(objectY, neighborX);
        }
        return { objectFits, shouldBeRotated };
    }
    objectsSidesFit() {
        if (!this.objectNeighborNormal || !this.snappingTool.neighborObject) {
            return undefined;
        }
        return this.objectFitsNeighborSide(this.snappingTool.neighborObject, this.objectNeighborNormal.clone());
    }
    /**
     * compensateSideDiffs
     */
    compensateSideDiffs() {
        const fittingData = this.objectsSidesFit();
        if (!fittingData) {
            return;
        }
        if (!fittingData.objectFits || fittingData.shouldBeRotated) {
            this.snappingTool.getObject().rotateZ(Math.PI / 2);
        }
    }
    checkCenterPosition(normal, threshold) {
        var _a;
        const currentObject = this.snappingTool.getObject();
        if (!currentObject) {
            return undefined;
        }
        const neighborObjectId = (_a = this.objectNeighbor) === null || _a === void 0 ? void 0 : _a.object.name.split('|')[1];
        if (!neighborObjectId) {
            return undefined;
        }
        const neighborObject = this.viewer.getObjectById(neighborObjectId);
        if (!neighborObject) {
            return undefined;
        }
        if (!(0, utils_3d_1.isExtrusion)(neighborObject)) {
            return undefined;
        }
        return utils_2.Utils.calculateCenterSnappingPosition(currentObject, neighborObject, normal, threshold);
    }
    snapToPointerPositionOnMove() {
        var _a;
        this.anchorTestResult = this.viewer.calcHover();
        const { anchorTestResult } = this;
        this.scalingTool.removePanelCubes();
        const snappingObject = this.snappingTool.getObject();
        const hoveredObject = this.viewer.getObjectById((_a = anchorTestResult.objectUUID) !== null && _a !== void 0 ? _a : '');
        if (snappingObject && hoveredObject) {
            const [shouldPreviewPartBeHidden, shouldNeighborBeHighlightedInRed] = utils_2.Utils.isSnappingAllowed(snappingObject, hoveredObject, anchorTestResult.resultType);
            if (shouldPreviewPartBeHidden) {
                snappingObject.visible = false;
                this.snapHelper.clearPlaneHighlight();
                this.highlightingTool.clearConnectionHighlight();
                if (shouldNeighborBeHighlightedInRed) {
                    this.highlightingTool.highlightObject(hoveredObject);
                }
                return;
            }
            snappingObject.visible = true;
            if (snappingObject.type === types_1.ITEM_TYPE.PANEL) {
                const panel = snappingObject;
                panel.restoreStandardGeometry();
                this.panelInsertHelper.resetScaleForPanel(panel);
            }
            if ((0, utils_3d_1.isCoverComponent)(snappingObject)) {
                if (anchorTestResult.resultType === AnchorDetection_3d_1.AnchorResultType.slot) {
                    this.snappingTool.snapBySnappingPoints(anchorTestResult);
                }
                return;
            }
            if ((anchorTestResult.resultType === AnchorDetection_3d_1.AnchorResultType.box && (hoveredObject === null || hoveredObject === void 0 ? void 0 : hoveredObject.type) !== types_1.ITEM_TYPE.PANEL) ||
                !snappingObject.hasSnappingMetadata) {
                const normal = anchorTestResult.intersectionNormal;
                const neighborFaceDirection = utils_2.Utils.vecToLetter(normal);
                const moveDirection = utils_2.Utils.negateVectorLetter(neighborFaceDirection);
                this.highlightingTool.clearConnectionHighlight();
                this.snappingTool.rotateObjectToFaceTarget(hoveredObject, normal);
                this.snappingTool.moveObjectToTarget(moveDirection, neighborFaceDirection, {
                    direction: moveDirection,
                    intersection: this.intersectionPointOnTheMesh,
                });
                // redundant rotate in case if component was aligned by extrusion axis
                if (!this.snappingTool.isComponentAlignByExtrusion) {
                    this.compensateSideDiffs();
                }
                this.snapToNeighbor(normal);
                snappingObject.snapped = true;
            }
            else {
                this.viewer.toggleAnimationMode();
                const lastRotationBeforeSnap = snappingObject.quaternion.clone();
                const lastPositionBeforeSnap = snappingObject.position.clone();
                const snappedToAngledExtrusionBeforeSnap = snappingObject.snappedToAngledExtrusion;
                const snapped = this.snappingTool.snapBySnappingPoints(anchorTestResult);
                if (!snapped) {
                    snappingObject.snapped = false;
                    snappingObject.setPosition(lastPositionBeforeSnap);
                    snappingObject.setRotation(lastRotationBeforeSnap);
                    snappingObject.snappedToAngledExtrusion = snappedToAngledExtrusionBeforeSnap;
                }
                const centerPosition = this.checkCenterPosition(anchorTestResult.intersectionNormal, consts_2.consts.SNAP_TO_THE_CENTER_THRESHOLD);
                if (centerPosition &&
                    !_1.SnappingTool.shouldNotBeCentered(snappingObject) &&
                    !snappingObject.snappedToAngledExtrusion) {
                    snappingObject.objectSnappedToTheCenter = true;
                    snappingObject.setPosition(centerPosition);
                }
                else {
                    snappingObject.objectSnappedToTheCenter = false;
                }
                this.viewer.toggleAnimationMode();
            }
            this.snappingTool.lightClosestNeighbors(hoveredObject);
            if (snappingObject.type === types_1.ITEM_TYPE.PANEL && hoveredObject.type === types_1.ITEM_TYPE.EXTRUSION) {
                if (anchorTestResult.resultType === AnchorDetection_3d_1.AnchorResultType.slot) {
                    const hoveredSlot = anchorTestResult.resultData[0];
                    this.panelInsertionType = this.panelInsertHelper.insert(anchorTestResult.intersectionPoint, snappingObject, hoveredObject, hoveredSlot)
                        ? types_1.PANEL_INSERTION_TYPE.CONTOUR
                        : types_1.PANEL_INSERTION_TYPE.DEFAULT;
                }
                if (this.panelInsertionType !== types_1.PANEL_INSERTION_TYPE.CONTOUR) {
                    if (utils_2.Utils.isPlasticPanel(snappingObject) && !hoveredObject.scalingAngle && !this.copyInProgress) {
                        this.scalingTool.firstPanelAnchor = this.scalingTool.calculatePanelAnchor(snappingObject, anchorTestResult);
                        snappingObject.setPosition(this.scalingTool.firstPanelAnchor.origin
                            .clone()
                            .add(snappingObject.xDirection.clone().multiplyScalar(snappingObject.getWidth() / 2))
                            .add(snappingObject.yDirection.clone().multiplyScalar(snappingObject.getHeight() / 2)));
                        this.resizePanelToMatchAnchorSize(snappingObject, this.scalingTool.firstPanelAnchor);
                        snappingObject.positionOnDown = snappingObject.position.clone();
                        snappingObject.scaleOnDown = snappingObject.getScale().clone();
                        this.scalingTool.addPanelCubes();
                        if (anchorTestResult.resultType === AnchorDetection_3d_1.AnchorResultType.slot) {
                            const slot = anchorTestResult.resultData[0];
                            this.scalingTool.updateIntersectionPlane(slot.normal, slot.surfacePoint);
                            this.scalingTool.panelCubesSize = slot.width;
                        }
                        else if (anchorTestResult.resultType === AnchorDetection_3d_1.AnchorResultType.snapPt) {
                            const snappingPoint = anchorTestResult.resultData[0];
                            this.scalingTool.updateIntersectionPlane(snappingPoint.normal, snappingPoint.origin);
                            this.scalingTool.panelCubesSize = consts_2.consts.DEFAULT_PANEL_CUBE_SIZE;
                        }
                    }
                    this.panelInsertionType = types_1.PANEL_INSERTION_TYPE.SIDE_OR_END;
                }
            }
        }
        else {
            if ((snappingObject === null || snappingObject === void 0 ? void 0 : snappingObject.type) === types_1.ITEM_TYPE.PANEL) {
                this.panelInsertHelper.clearScaledPanel(snappingObject);
                this.panelInsertionType = types_1.PANEL_INSERTION_TYPE.DEFAULT;
            }
            this.snappingTool.clearDetectedNeighbor();
        }
    }
    snapToNeighbor(normal) {
        this.snappingTool.getObject().objectSnappedToTheEdge = false;
        this.snappingTool.getObject().objectSnappedToTheCenter = false;
        if (!this.snappingTool.getObject().isRotatedForSnapping) {
            return;
        }
        const borderPosition = this.checkBorderPosition(normal, consts_2.consts.SNAP_TO_THE_EDGE_THRESHOLD);
        if (borderPosition) {
            this.snappingTool.getObject().objectSnappedToTheEdge = true;
            this.snappingTool.getObject().setPosition(borderPosition);
            return;
        }
        const centerPosition = this.checkCenterPosition(normal, consts_2.consts.SNAP_TO_THE_CENTER_THRESHOLD);
        if (centerPosition) {
            this.snappingTool.getObject().objectSnappedToTheCenter = true;
            this.snappingTool.getObject().setPosition(centerPosition);
        }
    }
    resizePanelToMatchAnchorSize(panel, anchor) {
        const oldPanelSize = panel.getSize();
        const newPanelSize = anchor.xyOffsets.clone().multiplyScalar(2);
        if (newPanelSize.x > 0 && newPanelSize.y > 0) {
            const oldPanelWidth = oldPanelSize.x;
            const oldPanelHeight = oldPanelSize.y;
            const newPanelWidth = newPanelSize.x;
            const newPanelHeight = newPanelSize.y;
            panel.setSizeX(newPanelWidth, false);
            panel.setSizeY(newPanelHeight, false);
            panel.translateX((newPanelWidth - oldPanelWidth) / 2);
            panel.translateY((newPanelHeight - oldPanelHeight) / 2);
        }
    }
    onModelFileLoaded(loadedModel) {
        if (!this.selectedCatalogItem) {
            return;
        }
        const catalogItem = this.selectedCatalogItem;
        const object = loadedModel;
        object.initBoxes();
        object.setCatalogProps(catalogItem);
        this.viewer.props.setLoadingModel(false);
        this.viewer.props.setSelectedTool('draw');
        this.capHelper.removeCones();
        if (utils_2.Utils.isEndCap(catalogItem)) {
            this.capHelper.drawCones(object, catalogItem.series.map((seriesItem) => seriesItem.id));
            const objCopy = object.clone();
            this.scalingTool.setObject(objCopy);
        }
        else {
            this.scalingDirection = consts_2.consts.DEFAULT_SCALING_DIRECTION; // setting scalingDirection to default;
            this.viewer.getBackgroundPlane().position.set(0, 0, 0);
            this.draggingInProgress = true;
            this.disableFeatures = false;
            // eslint-disable-next-line no-param-reassign
            object.visible = false;
            this.viewer.getScene().add(object);
            this.scalingTool.setObject(object);
            this.dragControls.setObjects([object]);
            this.dragControls.setPositionShift(null);
            this.dragControls.endDraggingOnMouseCancel = false;
            this.snappingTool.setObject(object);
        }
    }
    loadModels(catalogItems) {
        return Promise.all(catalogItems.map((item) => this.loader.loadFile(item)));
    }
    finishCopyObjectsInserting() {
        return __awaiter(this, void 0, void 0, function* () {
            const sleep = (ms) => {
                // eslint-disable-next-line no-promise-executor-return
                return new Promise((resolve) => setTimeout(resolve, ms));
            };
            if (this.copyingObjects.some((object) => !object.visible)) {
                return;
            }
            this.objectsInsertingIsFinished = false;
            this.finalizeObjectsInsertion(this.copyingObjects);
            while (!this.objectsInsertingIsFinished) {
                // eslint-disable-next-line no-await-in-loop
                yield sleep(100);
            }
            this.dragControls.getObjects().forEach((object) => {
                object.unselect();
            });
            this.escapeClear();
            this.copyingObjects.forEach((object) => {
                // eslint-disable-next-line no-param-reassign
                object.copyInfo = null;
            });
            this.copyingObjects = [];
            this.viewer.props.setToolToDefault();
            this.dragControls.setObjects([]);
        });
    }
    setObjectInitialPosition(position) {
        this.insertedObjectInitialPosition = position;
    }
    insertObjectPreviewToTheScene() {
        const objectToInsert = this.snappingTool.getObject();
        if (!utils_2.Utils.validateIfObjectInsertingCanBeStartedAndShowErrors(objectToInsert, this)) {
            return false;
        }
        this.viewer.getScene().add(objectToInsert);
        this.setObjectInitialPosition(new three_1.Vector3(0, 0, 0).copy(objectToInsert.position));
        this.viewer.slidePlane.position.z = objectToInsert.position.z;
        this.viewer
            .getBackgroundPlane()
            .position.set(objectToInsert.position.x, objectToInsert.position.y, objectToInsert.position.z);
        this.scalingTool.setObject(objectToInsert);
        this.snappingTool.initObjectTransformation();
        this.snappingTool.hideHighlightedObject();
        this.highlightingTool.clearConnectionHighlight();
        return true;
    }
    insertScaledObjectsToTheScene(objectsToInsert) {
        if (objectsToInsert.length && this.scalingTool.collidedItem) {
            this.scalingTool.clearCollided();
        }
        objectsToInsert.forEach((objectToInsert) => {
            // removing the object preview
            // to replace with scaled and/or snapped object
            // from snapping tool
            this.viewer.getScene().remove(objectToInsert);
        });
        const cmd = new commands_1.AddObjectCommand(objectsToInsert, this.viewer, this.historyService);
        this.historyService.execute(cmd);
    }
    finalizeObjectsInsertion(objects = undefined) {
        var _a;
        if (!objects) {
            if (this.snappingTool.getObject()) {
                // eslint-disable-next-line no-param-reassign
                objects = [this.snappingTool.getObject()];
            }
            else if (this.transformControlsInitial.object) {
                // eslint-disable-next-line no-param-reassign
                objects = [this.transformControlsInitial.object];
            }
        }
        if (objects === null || objects === void 0 ? void 0 : objects.length) {
            this.insertScaledObjectsToTheScene(objects);
        }
        const additionalObjects = this.snappingTool.getTempObjects();
        if ((additionalObjects === null || additionalObjects === void 0 ? void 0 : additionalObjects.size) > 0) {
            additionalObjects.forEach((obj) => {
                this.insertScaledObjectsToTheScene([obj]);
            });
        }
        if ((_a = this.scalingTool.slicingTool) === null || _a === void 0 ? void 0 : _a.clipMesh) {
            this.scalingTool.slicingTool.resetClipMesh();
            this.scalingTool.objectPosition = null;
            this.scalingTool.initialSize = null;
        }
        this.snappingTool.setIsObjectVertical();
        this.clearTools();
        this.halfSideAngled = null;
        this.drawingAngledLock = false;
        this.snapHelper.clearPlaneHighlight();
        this.highlightingTool.clearConnectionHighlight();
        this.viewer.updateBuildPlanePosition();
    }
    finalizePanelInsertion() {
        const panel = this.snappingTool.getObject();
        if (!panel) {
            return;
        }
        if (utils_2.Utils.isPlasticPanel(panel) && !panel.isWireMesh()) {
            try {
                (0, PlasticPanelCutouts_3d_1.applyPlasticPanelCutouts)(panel, this.viewer.getScene().children.filter(utils_3d_1.isExtrusion));
            }
            catch (error) {
                panel.showErrorBox();
                document.body.dispatchEvent((0, events_2.dispatchNotificationEvent)({
                    message: error instanceof Error ? error.message : notifications['panel-placement-error'],
                    type: 'error',
                }));
                return;
            }
        }
        this.viewer.collisionProcessor.notifyObjectUpdated(panel, true);
        if (!panel.isCollided && this.scalingTool.isPanelSnapped) {
            if (this.validatePanelPlacement(panel)) {
                panel.hideErrorBox();
                this.insertScaledObjectsToTheScene([panel]);
                this.scalingTool.removePanelCubes();
                this.viewer.updateBuildPlanePosition();
                this.clearTools();
            }
            else {
                panel.showErrorBox();
                document.body.dispatchEvent((0, events_2.dispatchNotificationEvent)({
                    message: notifications['panel-placement-error'],
                    type: 'error',
                }));
            }
        }
    }
    validatePanelPlacement(panel) {
        return this.viewer.collisionProcessor
            .testCollisions(panel, new OBB_js_1.OBB().fromBox3((0, utils_3d_1.expandBBox)((0, utils_3d_1.getAABBox)(panel), panel.directionNormal, consts_2.consts.MAX_SLOT_DETECTION_DISTANCE)), {
            excludeIDs: new Set([panel.uuid]),
            useObbInsteadOfMeshCollision: true,
        })
            .indices.some((index) => {
            const object = this.viewer.getObjectById(this.viewer.collisionProcessor.getObjUUID(index));
            return (object instanceof _1.BaseObject3D &&
                (0, utils_3d_1.isExtrusion)(object) &&
                !(0, utils_3d_1.areVectorsCollinear)(object.directionNormal, panel.directionNormal));
        });
    }
    updateLabelsPositions() {
        if (this.transformControlsInitial.object) {
            const labelDiv = document.getElementById(Cad3d_scss_1.default.lengthLabel);
            const labelPosition = utils_2.Utils.objectPositionToScreenPosition(this.transformControlsInitial.object, this.viewer.getCamera(), true);
            labelDiv.style.left = `${labelPosition.x}px`;
            labelDiv.style.top = `${labelPosition.y - 30}px`;
        }
        this.dimensioningTool.updateLabelsPositions();
    }
    clearTools() {
        this.snappingTool.clearObject();
        this.scalingTool.clearObject();
        this.scalingTool.clearCollided();
        this.dimensioningTool.dispose();
        this.highlightingTool.clearConnectionHighlight();
        this.scalingInProgress = false;
        this.draggingInProgress = false;
        this.disableFeatures = false;
        this.viewer.slidePlane.setRotationFromEuler(this.viewer.slidePlaneInitialRotation);
    }
    terminatePartInserting() {
        this.disableFeatures = false;
        // terminating non-snapped part insertion
        const objects = this.copyInProgress ? this.copyingObjects : [this.snappingTool.getObject()];
        objects.forEach((object) => {
            if (utils_2.Utils.isPlasticPanel(object) && this.panelInsertionType === types_1.PANEL_INSERTION_TYPE.SIDE_OR_END) {
                this.scalingTool.removePanelCubes();
                this.viewer.collisionProcessor.notifyObjectRemoved(object);
            }
            this.viewer.getScene().remove(object);
        });
        this.copyingObjects = [];
        this.snappingTool.clearObject();
        this.scalingTool.clearObject();
        this.dimensioningTool.dispose();
        this.highlightingTool.clearConnectionHighlight();
        this.snapHelper.clearPlaneHighlight();
        this.draggingInProgress = false;
        this.scalingInProgress = false;
        this.transformationInProgress = false;
    }
    removeObjects(uuids) {
        this.scalingTool.clearObject();
        this.snappingTool.clearObject();
        this.dimensioningTool.dispose();
        this.highlightingTool.clearConnectionHighlight();
        this.removeTransformControlsFromScene();
        const objectsToRemove = new Set();
        uuids.forEach((uuid) => {
            const objectToRemove = this.viewer.getObjectById(uuid);
            if (objectToRemove) {
                objectsToRemove.add(objectToRemove);
                objectToRemove.getTransformChildObjects().forEach((object) => {
                    objectsToRemove.add(object);
                });
            }
        });
        this.historyService.execute(new commands_1.RemoveObjectCommand(Array.from(objectsToRemove), this.viewer, this.historyService));
        const customObjects = this.viewer.getScene().children.filter((child) => child.isCustomObject);
        if (customObjects.length > 1) {
            this.scalingTool.setScalingValuesForGrid();
        }
    }
    refreshScene() {
        this.capHelper.removeCones();
        this.selectionTool.unselectAll();
        this.historyService.history.clear();
        this.viewer.props.setToolToDefault();
        this.viewer.handleEscape();
        const objectsToDelete = [];
        this.viewer.getScene().children.forEach((obj) => {
            var _a;
            if (obj instanceof _1.BaseObject3D && obj.isCustomObject && obj.uuid !== ((_a = this.snappingTool.getObject()) === null || _a === void 0 ? void 0 : _a.uuid)) {
                objectsToDelete.push(obj);
            }
        });
        objectsToDelete.forEach((obj) => {
            const isCustomObject = obj instanceof _1.BaseObject3D && obj.isCustomObject;
            obj.removeFromParent();
            if (isCustomObject) {
                this.viewer.collisionProcessor.notifyObjectRemoved(obj);
            }
        });
        this.highlightingTool.clearConnectionHighlight();
        this.dimensioningTool.dispose();
        this.connectionManager.clearConnections();
    }
    removeObjectFromTheScene(objectToRemove) {
        var _a, _b;
        if (objectToRemove) {
            (_a = objectToRemove.geometry) === null || _a === void 0 ? void 0 : _a.dispose();
            (_b = objectToRemove.material) === null || _b === void 0 ? void 0 : _b.dispose(); // TODO: dispose array of materials as well
            this.viewer.getScene().remove(objectToRemove);
            this.viewer.getRenderer().renderLists.dispose();
        }
    }
    undoCommand() {
        var _a;
        if (this.viewer.props.isFastenerWidgetShown) {
            return;
        }
        this.selectionTool.unselectAll();
        (_a = this.transformControlsInitial) === null || _a === void 0 ? void 0 : _a.detach();
        this.historyService.undo();
    }
    redoCommand() {
        var _a;
        if (this.viewer.props.isFastenerWidgetShown) {
            return;
        }
        (_a = this.transformControlsInitial) === null || _a === void 0 ? void 0 : _a.detach();
        this.historyService.redo();
    }
    copyAction() {
        var _a;
        const selectedObjects = this.selectionTool.selectedObjects.filter((item) => item instanceof _1.BaseObject3D && item.isCustomObject);
        if (!selectedObjects.length) {
            return;
        }
        if (selectedObjects.length === 1 && selectedObjects[0].scalingAngle) {
            utils_1.Events.showNotification({
                message: notifications['angled-copy-warning'],
                type: 'warning',
            });
            return;
        }
        this.copyingObjects = [];
        const masterPartId = (_a = this.selectionTool.getMasterPart()) === null || _a === void 0 ? void 0 : _a.uuid;
        if (masterPartId) {
            this.initCopyBuffer(masterPartId, selectedObjects);
        }
    }
    initCopyBuffer(masterPartId, objects) {
        let masterPartPosition;
        this.copyBuffer.forEach((object) => {
            object.copyInfo = null;
        });
        this.copyBuffer = [];
        objects.forEach((object) => {
            if (this.copyBuffer.some((existObject) => { var _a; return ((_a = existObject.copyInfo) === null || _a === void 0 ? void 0 : _a.originObjectId) === object.uuid; })) {
                return;
            }
            const isMasterPart = object.uuid === masterPartId;
            if (isMasterPart) {
                masterPartPosition = object.position;
            }
            const copyObject = object.clone();
            if ((0, utils_3d_1.isPanel)(object)) {
                const panel = object;
                if (panel.basePosition) {
                    copyObject.setPosition(panel.basePosition);
                }
            }
            copyObject.select();
            copyObject.copyInfo = new BaseObject3D_3d_1.CopyInfo();
            const { copyInfo } = copyObject;
            copyInfo.isMasterPart = isMasterPart;
            copyInfo.originQuaternion = copyObject.quaternion.clone();
            copyInfo.originZ = copyObject.position.z;
            copyInfo.originObjectId = object.uuid;
            object.getTransformChildObjects().forEach((childObject) => {
                if (this.copyBuffer.some((existObject) => { var _a; return ((_a = existObject.copyInfo) === null || _a === void 0 ? void 0 : _a.originObjectId) === childObject.uuid; })) {
                    return;
                }
                const copyChildObject = childObject.clone();
                copyChildObject.copyInfo = new BaseObject3D_3d_1.CopyInfo();
                copyChildObject.copyInfo.originObjectId = childObject.uuid;
                copyChildObject.select();
                this.copyBuffer.push(copyChildObject);
            });
            object.connectedItems.forEach((connectionItem) => {
                const connectedObject = this.viewer.getObjectById(connectionItem.uuid);
                if (!connectedObject) {
                    return;
                }
                const originConnection = this.connectionManager.findConnectionBetween(object.uuid, connectedObject.uuid);
                if (!originConnection) {
                    return;
                }
                const { fastenerItemNumber, numberOfFasteners, fastenersMetadata, distanceToTheEdge, holeDepth, numberOfSlotsWithFastenersOnConnectedExtrusion, } = originConnection;
                const fastenerCopyInfo = {
                    toOriginObject: connectedObject.uuid,
                    fastenerItemNumber,
                    numberOfFasteners,
                    holeDepth,
                    distanceToTheEdge,
                    fastenersMetadata,
                    numberOfSlotsWithFastenersOnConnectedExtrusion,
                };
                copyInfo.fasteners.push(fastenerCopyInfo);
            });
            this.copyBuffer.push(copyObject);
        });
        this.copyBuffer
            .filter((object) => {
            var _a;
            return !((_a = object.copyInfo) === null || _a === void 0 ? void 0 : _a.isMasterPart);
        })
            .forEach((object) => {
            const shift = masterPartPosition.clone().sub(object.position);
            if (object.copyInfo) {
                // eslint-disable-next-line no-param-reassign
                object.copyInfo.shiftToMasterPart = shift;
            }
        });
    }
    pasteAction() {
        const draggedObjects = this.dragControls.getObjects();
        if (draggedObjects && draggedObjects.length) {
            return;
        }
        this.scalingDirection = consts_2.consts.DEFAULT_SCALING_DIRECTION; // setting scalingDirection to default;
        if (!this.copyBuffer || !this.copyBuffer.length) {
            return;
        }
        this.copyingObjects = this.copyBuffer.map((object) => object.clone());
        const masterPart = this.copyingObjects.find((object) => { var _a; return (_a = object.copyInfo) === null || _a === void 0 ? void 0 : _a.isMasterPart; });
        if (!masterPart) {
            return;
        }
        this.snappingTool.setObject(masterPart);
        this.scalingTool.setObject(masterPart);
        this.dragControls.setObjects(this.copyingObjects);
        this.dragControls.setPositionShift(null);
        this.dragControls.endDraggingOnMouseCancel = false;
        this.draggingInProgress = true;
        this.disableFeatures = false;
        this.copyingObjects.forEach((object) => this.viewer.getScene().add(object));
        if (this.lastMouseMoveEvent) {
            this.dragControls.onDocumentMouseMove(this.lastMouseMoveEvent);
        }
        this.viewer.props.setSelectedTool('draw');
        this.selectionTool.unselectAll();
    }
    removeTransformControlsFromScene() {
        if (this.scalingInProgress) {
            // if scale was enabled
            this.scalingInProgress = false;
            this.scalingTool.displayScalingValue(this.scalingTool.getObject());
        }
        this.transformControlsInitial.detach();
        this.viewer.props.setTransformToolToDefault();
        this.transformationInProgress = false;
    }
    resetLastScaledObject() {
        this.uuidScaleLast = '';
    }
    isOnlyOneCopyingPart() {
        if (this.copyingObjects.length === 1) {
            return true;
        }
        if (this.copyingObjects.filter((object) => object.type === types_1.ITEM_TYPE.EXTRUSION).length === 1) {
            return true;
        }
        return false;
    }
}
exports.default = DesignProMain;
